var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.compiledMarkdown)}}):_c('div',{staticClass:"flex justify-center"},[_c('Loader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }